import PhoneField from '~/components/forms/PhoneField'

export default function(formulateInstance) {
  formulateInstance.extend({
    components: {
      PhoneField
    },
    library: {
      phone: {
        classification: 'phone',
        component: 'PhoneField'
      }
    }
  })
}
